module.exports = __webpack_public_path__ + "img/elvis-fanday-89.678ff3ac.jpg";